import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Icon } from '@iconify/react'
import './style.css'

const FileUploadField = ({ 
    formHandler, 
    name, 
    label, 
    accept = "*/*", 
    multiple = false, 
    maxFiles = 1,
    helperText 
}) => {
    const { t } = useTranslation()
    const [selectedFiles, setSelectedFiles] = useState([])

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files)
        
        if (files.length > maxFiles) {
            alert(t('max-files-exceeded', { max: maxFiles }))
            return
        }

        setSelectedFiles(files)
        
        if (formHandler) {
            formHandler(name, files)
        }
    }

    return (
        <div className="file-upload-field">
            <label className="file-upload-label">{label}</label>
            
            <div className="file-upload-area">
                <input
                    type="file"
                    id={`file-${name}`}
                    accept={accept}
                    multiple={multiple}
                    onChange={handleFileChange}
                    className="file-input-hidden"
                />
                
                <label htmlFor={`file-${name}`} className="file-upload-button">
                    <Icon icon="mdi:cloud-upload" className="upload-icon" />
                    <span>{t('click-to-upload')}</span>
                </label>

                {selectedFiles.length > 0 && (
                    <div className="selected-files">
                        <p className="files-count">
                            {selectedFiles.length} {t('file-selected', { count: selectedFiles.length })}
                        </p>
                        <ul className="files-list">
                            {selectedFiles.map((file, index) => (
                                <li key={index} className="file-item">
                                    <Icon icon="mdi:file" />
                                    <span>{file.name}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>

            {helperText && <p className="helper-text">{helperText}</p>}
        </div>
    )
}

export default FileUploadField

